import { Controller } from '@hotwired/stimulus'

// One page load, one ping. The module-level set — rather than an instance field — is
// deliberate: the vacancy page carries three apply buttons (desktop top, mobile toolbar,
// desktop foot) and they are three controller instances, so an instance flag would let a
// visitor who resizes their window count twice. Keyed by URL, so moving to another
// vacancy through Turbo still counts.
const pinged = new Set()

// A plain fetch, not sendBeacon: the visitor stays on the page, so there is no unload
// race to win, and sendBeacon cannot set headers — which would mean giving up CSRF
// protection to gain nothing.
export default class extends Controller {
  static values = { url: String }

  track () {
    if (pinged.has(this.urlValue)) return
    pinged.add(this.urlValue)

    const token = document.querySelector('meta[name="csrf-token"]')

    window.fetch(this.urlValue, {
      method: 'POST',
      headers: token ? { 'X-CSRF-Token': token.content } : {},
      credentials: 'same-origin',
      keepalive: true
    }).catch(() => {})
  }
}
